import { getGtmEventQueue } from './gtmEventQueue.ts';
import { eventTypeConstants, eventNameConstants } from './constants.ts';
import { getBuyerId } from 'dibs-cookie-jar';

const SPRIG_DELAY_LOGGED_OUT = 5000;
const SPRIG_START_TIMESTAMP_KEY = 'sprigStartTimestamp';

const getTrackingDelay = (): number => {
    const isLoggedIn = !!getBuyerId(document.cookie);
    if (isLoggedIn) {
        return 0;
    }

    // logged out user must have a delay before tracking starts
    const currentTimestamp = Date.now();
    let startTimestamp = Number(sessionStorage.getItem(SPRIG_START_TIMESTAMP_KEY));
    if (!startTimestamp) {
        startTimestamp = currentTimestamp;
        sessionStorage.setItem(SPRIG_START_TIMESTAMP_KEY, String(startTimestamp));
    }
    const elapsedTime = currentTimestamp - startTimestamp;
    const delay = SPRIG_DELAY_LOGGED_OUT - elapsedTime;
    if (delay < 0) {
        return 0;
    }

    return delay;
};

export const initSprig = (): void => {
    const gtmData = {
        event: eventTypeConstants.EVENT_EVENT,
        eventName: eventNameConstants.EVENT_SPRIG,
    };

    const delay = getTrackingDelay();
    if (delay) {
        setTimeout(() => {
            getGtmEventQueue().push(gtmData);
        }, delay);
    } else {
        getGtmEventQueue().push(gtmData);
    }
};
